// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8rRVN","badges":"styles_badges__rJtk5"};